import { Component, Input } from '@angular/core';
import { MemberResponseInterface } from '@careapp/angular-sdk';

@Component({
  selector: 'category-list',
  templateUrl: './category-list.component.html',
  styleUrls: ['./category-list.component.scss']
})
export class CategoryListComponent {
  @Input()
  headings: Array<{ label?: string; icon?: string }>;

  @Input()
  emptyMessage: string;

  @Input()
  list: Array<{
    id: string;
    name: string;
    icon: string;
    score: number;
  }>;
}
